import gql from "graphql-tag";

export const REFLECTIONS_QUERY = gql`
  query refections($userId: ID, $date_Lte: Date, $date_Gte: Date) {
    sleepLog(userId: $userId, date_Lte: $date_Lte, date_Gte: $date_Gte) {
      edges {
        node {
          id
          date
          seconds
          rating
        }
      }
    }
    hydrationLog(userId: $userId, date_Lte: $date_Lte, date_Gte: $date_Gte) {
      edges {
        node {
          id
          date
          rating
          milliliters
        }
      }
    }
    userMood(userId: $userId, date_Gte: $date_Gte, date_Lte: $date_Lte) {
      edges {
        node {
          id
          date
          mood
        }
      }
    }
    userFeelings(userId: $userId, date_Gte: $date_Gte, date_Lte: $date_Lte) {
      edges {
        node {
          id
          date
          feeling {
            id
            title
            hexCode
          }
        }
      }
    }
  }
`;
